<template>
    <v-container fluid grid-list-md>
        <v-dialog v-model="dialog" width="600px">
            <v-card>
                <div
                        :key="i"
                        v-for="(item, i) in paragraphs"
                >
                    <v-img
                            v-if="item.type == 'img'"
                            :src=item.img
                            height="400px"
                    ></v-img>
                    <v-list
                            three-line
                            v-if="item.type == 'paragraph'"
                    >
                        <v-list-tile
                                :key="j"
                                v-for="(parag, j) in item.paragraph"
                        >
                            <v-list-tile-content>
                                <v-list-tile-title>{{parag.title}}</v-list-tile-title>
                                <v-list-tile-sub-title>{{parag.text}}</v-list-tile-sub-title>
                            </v-list-tile-content>
                        </v-list-tile>
                    </v-list>
                </div>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="green darken-1" flat="flat" @click="dialog = false">{{close}}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-layout row wrap>
            <v-flex d-flex xs12 sm6 md9>
                <v-card color="white">
                  <v-card-title primary class="title grey ">
                    <span><v-icon large color="white">fiber_manual_record</v-icon></span>{{newsNavTitle}}
                  </v-card-title>
                    <v-container grid-list-md text-xs-left>
                        <v-layout row wrap
                                  :key="newsIndex"
                                  v-for="(newsItem, newsIndex) in newsArray"
                        >
                            <v-flex xs12>
                            <v-card flat>
                                <v-card-text>
                                    <v-layout align-center mb-3>
                                        <!--<v-avatar color="grey" class="mr-3"></v-avatar>-->
                                        <v-avatar
                                                v-if="imgs[newsIndex][newsItem.avatarIndex]"
                                                size="100"
                                                color="grey lighten-4"
                                        >
                                            <img :src="imgs[newsIndex][newsItem.avatarIndex]">
                                        </v-avatar>
                                        <strong class="title">{{newsItem.title}}</strong>
                                    </v-layout>
                                    <div
                                            v-if="!newsItem.opened"
                                    >
                                        <div>
                                            <h3>{{getNewsTitle(newsItem.info)}}</h3>
                                            <p>
                                                {{getNewsText(newsItem.info)}}
                                            </p>
                                        </div>
                                    </div>
                                    <div
                                            v-if="newsItem.opened"
                                            :key="i"
                                            v-for="(item, i) in newsItem.info"
                                    >
                                        <v-container
                                                v-if="item.type == 'img'"
                                                fluid grid-list-sm
                                        >
                                            <v-layout justify-center>
                                                <v-flex xs2 sm2
                                                >
                                                </v-flex>
                                                <v-flex xs8 sm8
                                                >
                                                    <v-card>
                                                        <v-img
                                                                v-if="imgs[newsIndex][item.index]"
                                                                :src=imgs[newsIndex][item.index]
                                                                :max-height="item.height.length > 0 ? item.height : '400px'"
                                                                contain
                                                                class="grey darken-4"

                                                        ></v-img>
                                                    </v-card>
                                                </v-flex>
                                                <v-flex xs2 sm2
                                                >
                                                </v-flex>

                                            </v-layout>
                                        </v-container>

                                        <v-container
                                                v-if="item.type == 'grid'"
                                                fluid grid-list-sm
                                        >
                                            <v-layout>
                                                <v-flex xs6 sm4
                                                        :key="j"
                                                        v-for="(gridItem, j) in item.items"
                                                >
                                                    <v-img
                                                            v-if="imgs[newsIndex][gridItem.index]"
                                                            :src=imgs[newsIndex][gridItem.index]
                                                    ></v-img>
                                                </v-flex>
                                            </v-layout>
                                        </v-container>

                                        <div
                                                v-if="item.type == 'paragraph'"
                                                :key="inx"
                                                v-for="(par, inx) in item.paragraph"
                                        >
                                            <h3 v-if="par.title.length > 0">{{par.title}}</h3>
                                            <p>
                                                {{par.text}}
                                            </p>
                                        </div>
                                    </div>

                                </v-card-text>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn icon @click=readMore(newsIndex)>
                                        <v-icon>{{ newsItem.opened ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}</v-icon>
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                            <v-divider></v-divider>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-card>
            </v-flex>
            <v-flex d-flex xs12 sm6 md3>
                <v-card color="white">
                  <v-card-title primary class="title grey pa-4">
                    {{kontaktInfo1}}
                  </v-card-title>
                <v-card-text>
                    <p>{{ kontaktInfo2a }} {{ kontaktInfo2b }}</p>
                    <p>{{ kontaktInfo2c }}</p>

                    <p>{{ kontaktInfo3a }}</p>
                    <p>{{ kontaktInfo3b }}</p>
                    <p>{{ kontaktInfo3c }}</p>

                    <p>{{ kontaktInfo4a }}</p>
                    <p>{{ kontaktInfo4b }}</p>
                    <p>{{ kontaktInfo4c }}</p>
                </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
  import { mapState } from 'vuex'
  //import Dialog from './image-grid/Dialog'

  import * as newsLatest from '../store-modules/latest'
  import * as newsObj from '../store-modules/news'

  import { EventBus } from '../events'

  export default {
    data () {
      return {
        show: false,
        dialog: false,
        index: 0,
        title: '',
        text: '',
        newsArrayTest: [],
        paragraphs: [],
        imgsIndx: 0,
        imgs: [
            [
            ],

            [
                require('@/assets/news031.jpg'),
            ],

            [
                require('@/assets/news021.jpg'),
            ],

            [
                require('@/assets/news011.jpg'),
                require('@/assets/news012.jpg'),
                require('@/assets/news013.jpg'),
                require('@/assets/news014.jpg'),
                require('@/assets/news015.jpg'),
            ],
        ]
      }
    },
    mounted(){
      EventBus.$emit('show', false)
    },
    computed: {
        ...mapState('ContactModule', [
            'newsArray', 
            'latestNews', 
            'close',

            'kontaktInfo1',
            'kontaktInfo2a',
            'kontaktInfo2b',
            'kontaktInfo2c',
            'kontaktInfo3a',
            'kontaktInfo3b',
            'kontaktInfo3c',
            'kontaktInfo4a',
            'kontaktInfo4b',
            'kontaktInfo4c',

            'newsNavTitle',
          ]),
    },
    methods: {
        readMore(index){
            this.$store.dispatch('ContactModule/newsItemFullText', index)
        },
        getNewsTitle(news){
            var result = ''

            for(let i = 0; i < news.length; i++){
                if(news[i].type === 'paragraph'){
                    result = news[i].paragraph[0].title
                    break
                }
            }

            return result
        },

        getNewsText(news){
            var result = ''

            for(let i = 0; i < news.length; i++){
                if(news[i].type === 'paragraph'){
                    result = news[i].paragraph[0].text

                    if(result.length > 100){
                        result = result.substring(0, 1000)
                    }

                    result += ' ...'
                    break
                }
            }

            return result
        },
        onRead(index, language){
            this.index = index;
            var temporalNewsObj = newsObj.data[language];
            console.log(index);
            console.log(temporalNewsObj);
            console.log(newsLatest.data[language]);

            this.imgsIndx = index;

            if(index > 0){
                /*this.title = newsObj.data[language][index - 1].title;
                this.text = newsObj.data[language][index - 1].text;*/
                this.paragraphs = newsObj.data[language][index - 1].info;


            } else {
                /*this.title = newsLatest.data[language].title;
                this.text = newsLatest.data[language].text;*/
                this.paragraphs = newsLatest.data[language].info;
            }

            let j = 0;

            for(let i = 0; i < this.paragraphs.length; i++){
                if(this.paragraphs[i].type === 'img'){
                    this.paragraphs[i].img = this.imgs[index][j];
                    j++;
                }
            }

            this.dialog = true;
        },
    }
  }
</script>
